/**
 * Abtstract class representing an object which can log debug messages.
 * Can be attached to a Log with addLogger().
 */
 export default class Logger {

    constructor() {
        this.logPrefix = '';
    }

    setLogPrefix(prefix) {
        this.logPrefix = prefix;
    }

     /**
      * Logs a message to the console
      * @param {type}	level - Logging level
      * @param {type}	tag - Logging tag
      * @param {type}	text - Text to log
      */
    send(level, tag, text) {
        throw new Error('Logger should implement send()');
    }

    /**
     * Log an object.
     * @param {type}	level - Logging level
     * @param {type}	tag - Logging tag
     * @param {type}	text - Logging text
     * @param {type}	object - Object to be logged
     */
    sendObject(level, tag, text, object) {
        throw new Error('Logger should implement sendObject()');
    }
}



// WEBPACK FOOTER //
// ./src/utils/loggers/Logger.js